import { render, staticRenderFns } from "./DeviantReport.vue?vue&type=template&id=22dcbb5f&scoped=true&"
import script from "./DeviantReport.vue?vue&type=script&lang=ts&"
export * from "./DeviantReport.vue?vue&type=script&lang=ts&"
import style0 from "./DeviantReport.vue?vue&type=style&index=0&id=22dcbb5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcbb5f",
  null
  
)

export default component.exports